import { StandardEvents } from '@shopify/events';

class FreeShippingProgress extends HTMLElement {
  connectedCallback() {
    this.render(Number(this.dataset.total || 0));
    document.addEventListener(StandardEvents.cartLinesUpdate, this.handleCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.handleCartUpdate);
  }

  handleCartUpdate = (event) => {
    const update = event.promise instanceof Promise ? event.promise : Promise.resolve();
    update.finally(() => this.refresh());
  };

  async refresh() {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      const total = Number(cart.items_subtotal_price || 0);
      this.dataset.total = String(total);
      this.render(total);
    } catch (error) {
      console.warn('[free-shipping-progress] Unable to refresh cart total.', error);
    }
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', {
      style: 'currency',
      currency: this.dataset.currency || 'NZD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(cents / 100);
  }

  render(total) {
    const threshold = Number(this.dataset.threshold || 4000);
    const message = this.querySelector('[data-free-shipping-message]');
    const progress = this.querySelector('[data-free-shipping-progress]');
    if (!message || !progress || threshold <= 0) return;

    let copy;
    if (total <= 0) {
      copy = (this.dataset.emptyMessage || 'Free metro NZ shipping on orders {threshold}').replace(
        '{threshold}',
        this.formatMoney(threshold)
      );
    } else if (total < threshold) {
      copy = (this.dataset.remainingMessage || 'You’re {amount} away from free metro NZ shipping').replace(
        '{amount}',
        this.formatMoney(threshold - total)
      );
    } else {
      copy = this.dataset.unlockedMessage || 'You’ve unlocked free metro NZ shipping';
    }

    message.textContent = copy;
    progress.style.setProperty('--tr-free-shipping-progress', `${Math.min(100, (total / threshold) * 100)}%`);
    this.setAttribute('data-unlocked', total >= threshold ? 'true' : 'false');
  }
}

if (!customElements.get('free-shipping-progress')) {
  customElements.define('free-shipping-progress', FreeShippingProgress);
}
